/**
* Эффекты прокрутки
*/
function main(): void
{
	const scrollSensitiveElements : Array<Element> = Array.from( document.querySelectorAll( '[data-scroll-sensitive="yes"]' ) );

	if ( !scrollSensitiveElements.length )
	{
		return;
	}

	scrollSensitiveElements.forEach( ( it ) => {
		const showOnScroll = () => {
			if ( it.getBoundingClientRect().top < window.innerHeight / 2 )
			{
				it.classList.add( 'scrolled-to' );
				window.removeEventListener( 'scroll', showOnScroll );
			}
		};
		
		window.addEventListener( 'scroll', showOnScroll );
	} );
}

/**
 * Module.
 */
export {
	main as default,
};


// WEBPACK FOOTER //
// ./app/Routes/Index/ScrollSensitive/index.ts